export default function formatarDataISO(dataISO) {
    const data = new Date(dataISO);
    const dia = String(data.getUTCDate()).padStart(2, '0');
    const mes = String(data.getUTCMonth() + 1).padStart(2, '0');
    const ano = data.getUTCFullYear();
    let horas = data.getUTCHours();
    const minutos = String(data.getUTCMinutes()).padStart(2, '0');
    const dataFormatada = `${dia}/${mes}/${ano} às ${horas}h${minutos}`;
    return dataFormatada;
}